import { Dispatch, SetStateAction, createContext } from "react";

import { OpenAPI } from "simplydo/interfaces";

type ProjectBoardContextType = {
  forId: string;
  canEditProjectBoard: boolean;
  lanes: OpenAPI.GET<"/boards/{for_id}/lanes">["response"]["lanes"];
  loading: boolean;
  setPreviewId: Dispatch<SetStateAction<string>>;
  isSelecting: boolean;
  selectedIdeas: OpenAPI.Schemas["Idea"][];
  selectIdeas: (
    selectedIdeas: OpenAPI.Schemas["Idea"][],
    addToSelection: boolean,
  ) => void;
  checkUpdateProjectLane: (
    ideaIds: string[],
    laneId: string,
    order: number | null,
  ) => void;
};

export const ProjectBoardContext = createContext<ProjectBoardContextType>({
  forId: "",
  canEditProjectBoard: false,
  lanes: [],
  loading: false,
  setPreviewId: () => {},
  isSelecting: false,
  selectedIdeas: [],
  selectIdeas: () => {},
  checkUpdateProjectLane: () => {},
});
